<!--
@create date 2023-6-26
@desc m08f.phomemo.com
-->
<template>
  <div class="guides-div">
    <div class="topText" style="margin-bottom: 40px">
      <h1>Download for T310 BarcodePrinter</h1>
    </div>
    <!--   <hr style="color: rgba(51, 61, 71,0.3);width: 30%;margin-bottom: 50px;" v-show="!isMobile()" /> -->
    <div class="main-contain-t310">
      <!-- windows -->
      <div class="item-margin">
        <div style="margin-bottom: 35px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 10px auto 30px; width: 100px"
          />
          <a
            href="https://oss.qu-in.ltd/Phomemo/Label_Printer_Driver_Win.zip"
            class="a-link"
            >Driver for Windows</a
          ><br />
        </div>
      </div>
      <!-- mac -->
      <div class="item-margin">
        <div style="margin-bottom: 35px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto 30px; width: 100px"
          />
          <a
            href="https://oss.qu-in.com/BarcodePrinter/LabelPrinter-1.5.3.002.pkg"
            class="a-link"
            >Driver for Mac</a
          ><br />
        </div>
      </div>
      <!-- windows -->
      <div class="item-margin" style="padding: 10px 10px 20px 10px">
        <div style="margin-bottom: 5px; line-height: 20px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            href="https://oss.saas.aimocloud.com/saas/Lablife/bag/Windows/Labelife_Setup_v3.0.0.417_x86.exe"
            class="a-link"
            style="font-size: 14px"
            >Label Editor for Windows 32bit</a
          ><br />
          <a
            href="https://oss.saas.aimocloud.com/saas/Lablife/bag/Windows/Labelife_Setup_v3.0.0.417.exe"
            class="a-link"
            style="font-size: 14px; position: relative; top: 4px"
            >Label Editor for Windows 64bit</a
          >
        </div>
      </div>
      <!-- mac -->
      <div class="item-margin">
        <div style="margin-bottom: 35px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto 30px; width: 100px"
          />
          <a
            href="https://apps.apple.com/us/app/labelife/id1560922539?mt=12"
            class="a-link"
            >Label Editor for Mac</a
          ><br />
        </div>
      </div>
      <!-- mac -->
      <div class="item-margin">
        <div style="margin-bottom: 35px">
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/android600x600.png?v=1691551042"
            style="display: block; margin: 10px auto 30px; width: 100px"
          />
          <a
            href="https://play.google.com/store/apps/details?id=com.aimo.labelife"
            class="a-link"
            >Label Editor for Android</a
          ><br />
        </div>
      </div>
      <!-- mac -->
      <div class="item-margin">
        <div style="margin-bottom: 35px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto 30px; width: 100px"
          />
          <a
            href="https://apps.apple.com/cn/app/labelife/id1560922539"
            class="a-link"
            >Label Editor for iOS</a
          ><br />
        </div>
      </div>
    </div>

    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 66%; margin-bottom: 40px"
      v-show="!isMobile()"
    />

    <div
      class="main-contain-t310"
      style="max-width: 1200px; justify-content: left"
    >
      <!-- windows -->
      <div class="video-item-margin">
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/Driver Installation Tutorial (Mac).mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>Driver Installation Tutorial (Mac)</div>
      </div>
      <!-- mac -->
      <div class="video-item-margin">
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/Driver Installation Tutorial (windows).mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>Driver Installation Tutorial (windows)</div>
      </div>
      <!-- windows -->
      <!-- <div class="video-item-margin">
        <div class="video-contain">
          <video controls webkit-playsinline="true" class="video">
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to bluetooth connect printer on mac.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>How to bluetooth connect printer on mac</div>
      </div> -->
      <!-- mac -->
      <div class="video-item-margin">
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/How to bluetooth connect printer on phone.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>How to bluetooth connect printer on phone</div>
      </div>
      <!-- mac -->
      <!-- <div class="video-item-margin">
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to bluetooth connect printer on windows.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>How to bluetooth connect printer on windows</div>
      </div> -->
      <!-- mac -->
      <!-- <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to connect a printer to Ethernet on Windows（via editing software）.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>
          How to connect a printer to Ethernet on Windows（via editing
          software）
        </div>
      </div> -->
      <!-- 2023-10-10 -->
      <div class="video-item-margin">
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/networkPortForMac.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>How to connect a printer to Ethernet on Mac(via driver)</div>
      </div>

      <!-- 2024-1-3 -->
      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 25px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/How%C2%A0to%C2%A0connect%C2%A0a%C2%A0printer%C2%A0using%C2%A0Ethernet%C2%A0on%C2%A0Windows%EF%BC%88via%C2%A0driver%EF%BC%89.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>How to connect a printer to Ethernet on Windows（via driver）</div>
      </div>
      <!-- 2024-1-3 -->
      <!-- <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to connect a printer to Ethernet on Mac(via editing software).mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>
          How to connect a printer to Ethernet on Mac(via editing software)
        </div>
      </div> -->

      <!-- 2024-6-24 -->
      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/How to bluetooth connect printer(via editing software)封面.png"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to bluetooth connect printer(via editing software).mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>How to bluetooth connect printer(via editing software)</div>
      </div>

      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/How to connect a printer to Ethernet封面.png"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to connect a printer to Ethernet（via editing software）.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>How to connect a printer to Ethernet（via editing software）</div>
      </div>

      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/How to install ribbon and paper roll封面.png"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to install ribbon and paper roll.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>How to install ribbon and paper roll</div>
      </div>

      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/How to print with folded paper and external paper roll (including installation)封面.png"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to print with folded paper and external paper roll (including installation).mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>
          How to print with folded paper and external paper roll (including
          installation)
        </div>
      </div>

      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/How to print multi-row, multi-column labels (including installation)-封面.png"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to print multi-row, multi-column labels (including installation).mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>
          How to print multi-row, multi-column labels (including installation)
        </div>
      </div>

      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/How to print on black mark paper（(including installation)封面.png"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to print on black mark paper（(including installation).mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>How to print on black mark paper（(including installation)</div>
      </div>

      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/How to import data from an Excel spreadsheet into Labelife for batch printing封面.jpg"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to import data from an Excel spreadsheet into Labelife for batch printing.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>
          How to import data from an Excel spreadsheet into Labelife for batch
          printing
        </div>
      </div>

      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/How to crop and print Amazon FNSKU label封面.jpg"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to crop and print Amazon FNSKU label.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>How to crop and print Amazon FNSKU label</div>
      </div>

      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/How to crop and print Amazon 4x4 and 4x6 shipping label-封面.jpg"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/How to crop and print Amazon 4x4 and 4x6 shipping label.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>How to crop and print Amazon 4x4 and 4x6 shipping label</div>
      </div>

      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/hang tag 封面.png"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/hang tag （perforated paper）printing.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>Hang tag (perforated paper) printing</div>
      </div>

      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/labelife-how to create and print multi-column labels-封面.jpg"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/labelife-how to create and print multi-column labels.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>labelife-how to create and print multi-column labels</div>
      </div>

      <div class="video-item-margin">
        <div class="video-contain" style="margin-top: 20px">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 90%"
            poster="https://oss.qu-in.top/printerFiles/phomemo/t310/labelife--saves my templates and printing history封面.png"
          >
            <source
              src="https://oss.qu-in.top/printerFiles/phomemo/t310/labelife--saves my templates and printing history.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div>labelife--saves my templates and printing history</div>
      </div>
    </div>

    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 66%; margin-bottom: 40px"
      v-show="!isMobile()"
    />
    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 100%; margin-bottom: 40px"
      v-show="isMobile()"
    />
    <div class="customService" style="margin-top: 10px">
      <h1>Quick Start Guide</h1>
      <div>
        <a
          style="color: #1fc3ff; text-decoration: auto"
          href="https://oss.qu-in.top/printerFiles/phomemo/t310/T200 英-快速入门指南-a3折叠-241031-A3.pdf"
          target="_blank"
          >Click Here for A Quick Start Guide</a
        >
      </div>
    </div>
    <hr
      style="
        color: rgba(51, 61, 71, 0.3);
        width: 66%;
        margin: 45px auto;
        margin-top: 25px;
      "
      v-show="!isMobile()"
    />
    <hr
      style="
        color: rgba(51, 61, 71, 0.3);
        width: 100%;
        margin: 45px auto;
        margin-top: 25px;
      "
      v-show="isMobile()"
    />
    <div class="faq-content-area faq-area-t310">
      <h1 style="margin-bottom: 33px; margin-top: 30px; text-align: center">
        Frequently Asked Questions
      </h1>
      <div class="faq-container">
        <div class="faq-item" v-for="(item, index) in faqDataApp" :key="index">
          <div class="faq-title" @click="clickQuestion2(item, index)">
            <span v-text="item.title"></span>
            <img
              src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/f10e2c4832c0faf086185700b226c940.png?v=1646813187"
              class="downArrow"
              v-show="activeQuestion2.index === index"
            />
            <img
              src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/a016b412f93b877a827866a90379da25.png?v=1646813168"
              class="downArrow"
              v-show="activeQuestion2.index !== index"
            />
          </div>
          <div class="faq-scroll-area">
            <div
              v-show="!!item.img && activeQuestion2.index === index"
              style="padding-left: 40px; padding-top: 6px"
            >
              <img
                style="max-width: 180px; cursor: pointer"
                :src="item.img"
                @click="
                  () => {
                    window.open(item.img);
                  }
                "
                title="Click to view the original image"
              />
            </div>
            <div
              class="faq-content"
              v-show="activeQuestion2.index === index"
              v-for="(child, index2) in item.details"
              :key="index2"
            >
              <div class="content-title" v-text="child.theme"></div>
              <div
                class="faq-content-children"
                v-for="(item3, index3) in child.children"
                :key="index3"
              >
                {{ item3.text }}
                <br v-show="item3.isWrap" /><br v-show="item3.isWrap" />
                <div
                  v-show="(item3.imgs && item3.imgs.length > 0) || item3.videos"
                  class="img-container"
                >
                  <img
                    v-for="(everyImg, index4) in item3.imgs"
                    :key="index4"
                    :src="everyImg"
                    @click="
                      () => {
                        window.open(everyImg);
                      }
                    "
                    title="Click to view the original image"
                  />
                  <video
                    v-for="everyVideo in item3.videos || []"
                    controls
                    webkit-playsinline="true"
                    class="video"
                    style="width: 450px"
                    :key="everyVideo.url"
                    :poster="everyVideo.poster"
                  >
                    <source :src="everyVideo.url" type="video/mp4" />
                    您的浏览器不支持 HTML5 video 标签。
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 66%; margin-top: 30px"
      v-show="!isMobile()"
    />
    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 100%; margin-top: 30px"
      v-show="isMobile()"
    />
    <div class="customService">
      <h1>Customer Service</h1>
      <div class="everyRow">
        Email：<a href="mailto:support@phomemo.com"
          >support@itaricartridge.com</a
        >
      </div>
      <div class="everyRow">Tel：+1 833 940 3818(US and CA only)</div>
      <div class="everyRow">Whatsapp：+86 1369 772 4676</div>
    </div>
  </div>
</template>

<script>
import { faqDataAppForT310 } from "./dataConfig.js";

const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
export default {
  name: "t310_itari",
  props: {},
  data() {
    return {
      window,
      faqDataApp: faqDataAppForT310,
      activeQuestion2: {},
      isMobile,
    };
  },
  mounted() {},
  methods: {
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
  },
};
</script>

<style lang="less" src="./style.less" />



// WEBPACK FOOTER //
// src/view/guides/t310_itari.vue